function initCustomMeasurement() {

    const measurementForm = document.getElementById("custom-measurement-form");

    if (!measurementForm) {
        requestAnimationFrame(initCustomMeasurement);
        return;
    }

    const fields = measurementForm.querySelectorAll("input, textarea");

    function setButtonsDisabled(disabled) {

    const addToCartBtn = document.querySelector(
        'button[name="add"], button[type="submit"][name="add"]'
    );

    const buyNowBtn = document.querySelector(
        '.shopify-payment-button button'
    );

    if (addToCartBtn) {
        addToCartBtn.disabled = disabled;
        addToCartBtn.classList.toggle("disabled", disabled);
    }

    if (buyNowBtn) {
        buyNowBtn.disabled = disabled;
        buyNowBtn.classList.toggle("disabled", disabled);
    }
}

    function isFormValid() {

    return [...fields].some(field => {

        if (field.type === "checkbox" || field.type === "radio") {
            return field.checked;
        }

        return field.value.trim() !== "";

    });

}

    function updateButtonState() {

        const selectedInputs = document.querySelectorAll(
            'variant-selects input[type="radio"]:checked'
        );

        let isCustom = false;

        selectedInputs.forEach(input => {
            if (input.value.trim().toLowerCase() === "custom") {
                isCustom = true;
            }
        });

        if (isCustom) {

            measurementForm.style.display = "block";

            setButtonsDisabled(!isFormValid());

        } else {

            measurementForm.style.display = "none";

            fields.forEach(field => {
                field.required = false;
            });

            setButtonsDisabled(false);

        }
    }

    // Variant change
    document.addEventListener("change", function(e) {
        if (e.target.matches("variant-selects input")) {
            updateButtonState();
        }
    });

    // Form input
    fields.forEach(field => {
        field.addEventListener("input", updateButtonState);
        field.addEventListener("change", updateButtonState);
    });

    updateButtonState();

    document.addEventListener("variant:change", updateButtonState);

    document.addEventListener("change", function () {
        setTimeout(updateButtonState, 50);
    });

}

initCustomMeasurement();